import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=6b096355&scoped=true"
import script from "./Publications.vue?vue&type=script&lang=js"
export * from "./Publications.vue?vue&type=script&lang=js"
import style0 from "./Publications.vue?vue&type=style&index=0&id=6b096355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b096355",
  null
  
)

export default component.exports